import { AxiosInstance, AxiosPromise } from 'axios';
import { Loadboard } from '../../../../types/Loadboard';
import { LoadboardEndpoint, LoadboardRequest } from './LoadboardServices.types';
import { RequestEndpoint, RequestServices } from './services';

export class LoadboardSevices implements LoadboardEndpoint {
  instance: AxiosInstance;
  requests: RequestEndpoint;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.requests = new RequestServices(instance);
  }

  post(request: LoadboardRequest): AxiosPromise<void> {
    return this.instance.put(`/loadboards/post/job/${request.routeParams.jobGuid}`, request.body);
  }

  unpost(request: LoadboardRequest): AxiosPromise<void> {
    return this.instance.delete(`/loadboards/post/job/${request.routeParams.jobGuid}`, {
      data: request.body,
    });
  }

  updateFreightPosts(request: LoadboardRequest): AxiosPromise<void> {
    return this.instance.put(
      `/loadboards/post/job/${request.routeParams.jobGuid}/update`,
      request.body,
    );
  }

  getLoadboardPosts(jobGuid: string): AxiosPromise<Loadboard[]> {
    return this.instance.get(`/loadboards/post/job/${jobGuid}`);
  }
}
